'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'font';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f031';
var svgPathData = 'M231.4 37c-1.2-3-4.2-5-7.4-5s-6.2 2-7.4 5L42.6 464 8 464c-4.4 0-8 3.6-8 8s3.6 8 8 8l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-44.1 0L112 336 336 336l52.1 128L344 464c-4.4 0-8 3.6-8 8s3.6 8 8 8l96 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-34.6 0L231.4 37zm98 283l-210.9 0L224 61.2 329.4 320z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFont = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;